import { setPermissions } from './utils'

export const setSubMenu = ({ agentPermissions, subItems }) => {
    const updatedSubItems = []

    subItems.forEach((item) => {
        let moduleName = item.link?.split('/')[1]

        // link is /intermediary-diary or /evidence-diary → token is module.intermediaryDiary.access
        // link is /reports → token is module.report.access
        if (moduleName === 'intermediary-diary' || moduleName === 'evidence-diary') {
            moduleName = 'intermediaryDiary'
        } else {
            moduleName = 'report'
        }

        const permission = `module.${moduleName}.access`
        const isLinkAvailable = setPermissions(agentPermissions, permission)
        const linkData = {
            ...item,
            isLinkAvailable,
            className: `nav-link ${!isLinkAvailable ? 'd-none' : ''}`
        }

        updatedSubItems.push(linkData)
    })

    return { updatedSubItems }
}
